<template>
  <!-- 正常 -->
  <page-wrapper
      v-if="error === undefined || Number(error) === 0"
      :title="title"
      :show-header-logo="showHeaderLogo !== 'false' && Boolean(showHeaderLogo)"
      :show-head-in="showHeadIn !== 'false' && Boolean(showHeadIn)"
      :show-head-button="showHeadButton !== 'false' && Boolean(showHeadButton)"
      :hide-magazine-form="hideMagazineForm !== 'false' && Boolean(hideMagazineForm)"
      :top="top !== 'false' && Boolean(top)">
    <slot />
  </page-wrapper>
  <!-- 混雑中 -->
  <page-wrapper v-else-if="Number(error) === 503" :title="titleFromApi || 'アクセスが集中しております'" class="error">
    <div class="error-content">
      <div class="wrapper">
        <center v-for="row in (message || '只今、アクセスが集中しております。/nしばらく経ってからお試しください。').split('/n')" :key="row">
          {{ row }}<br>
        </center>
      </div>
    </div>
  </page-wrapper>
  <!-- サーバーエラー -->
  <page-wrapper v-else-if="Number(error) === 500" :title="titleFromApi || 'エラーが発生しました'" class="error">
    <div class="error-content">
      <div class="wrapper">
        <center v-for="row in (message || 'エラーが発生しました。/nしばらく経ってからお試しください。').split('/n')" :key="row">
          {{ row }}<br>
        </center>
      </div>
    </div>
  </page-wrapper>
  <!-- 在庫なし -->
  <page-wrapper v-else-if="Number(error) === 5000" title="在庫が確保できませんでした" class="error">
    <div class="error-content">
      <div class="wrapper">
        <center>
          ご希望の車両の在庫が確保できませんでした。
        </center>
        <center>
          <router-link to="/" class="link-btn sans error-btn">
            TOPへ
          </router-link>
        </center>
      </div>
    </div>
  </page-wrapper>
  <!-- ページなし -->
  <page-wrapper v-else title="ページが見つかりませんでした" class="error">
    <div class="error-content">
      <div class="wrapper">
        <div class="error-content-text sans">
          お探しのページは見つかりませんでした。
        </div>
        <center>
          <router-link to="/" class="link-btn sans error-btn">
            TOPへ
          </router-link>
        </center>
      </div>
    </div>
  </page-wrapper>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';
import PageWrapper from './PageWrapper.vue';

export default defineComponent({
  components: {
    PageWrapper,
  },
  props: {
    /**
     * リクエストエラー コード。0またはundefinedの場合はエラーなしとして、通常のページ表示が行われます。
     */
    error: [Number, String],
    /**
     * ページ タイトル。
     */
    title: String,
    /**
     * true のとき、フッターのメルマガ登録フォームを非表示にします。
     */
    hideMagazineForm: [Boolean, String],

    showHeadIn: [Boolean, String],
    showHeadButton: [Boolean, String],

    /**
     * topページか否か。
     */
    top: [Boolean, String],
  },
  setup () {
    const route = useRoute();
    const message = ref(route.query?.message || '');
    const titleFromApi = ref(route.query?.title || '');

    return {
      message,
      titleFromApi,
    };
  },
});
</script>

<style lang="scss" scoped>
.error {
  padding-top: 80px;
}

/*----------------------------------------
エラーページ
----------------------------------------*/

.error-content {
	background: #f1f1f1;
	box-sizing: border-box;
	margin-top: 73px;
}

.error-content .wrapper {
  padding: 88px 0 56px;
}

.error-content-title {
	box-sizing: border-box;
	display: inline-block;
	font-weight: 700;
	font-size: 39px;
	line-height: 49px;
}

.error-content-text {
  box-sizing: border-box;
  font-size: 18px;
  line-height: 35px;
  letter-spacing: 0.04vw;
  margin-top: 52px;
  text-align: center;
}

.error-btn {
  background: #004da0;
  margin-top: 75px;
}

</style>
